import {IServiceProvider} from "angular";
import {Client, StompConfig} from "@stomp/stompjs";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import * as SockJS from "sockjs-client";

export class WebSocketProvider implements IServiceProvider {

    private client: Client;

    $get = (): Client => {
        return this.client;
    };

    constructor () {
        let stompConfig = this.stompConfig();
        let client = new Client(stompConfig);
        client.activate();
        this.client = client;
    }


    private stompConfig(): StompConfig {
        let stompConfig = new StompConfig();
        stompConfig.webSocketFactory = this.webSocketFactory;
        return stompConfig;
    }


    private webSocketFactory = () => {
        let url = getAbsoluteUrl('socket');
        return new SockJS(url);
    };

}

